/* ==========================================================================
   rx-tracking.js — Rolex data layer + Adobe Launch
   Ported from meridian-ecomm cmpScripts.js / cmpCollections.js.

   Differences from WordPress (on purpose):
   - The page name comes from the template (TEMPLATE_PAGE_TYPES below) or,
     when present, from the rx-page-meta section (#rx-page-meta), not from
     parsing the URL.
   - Launch is injected right after the data layer, on every rx template, with
     no consent check (Rolex requires it on every page). Consent is handled
     inside Launch through the rlx-consent / rlx-marketing cookies (set from
     CookieYes by rx-head + rx-consent.js).
   - No jQuery, no console logging.

   Config: <script type="application/json" id="rx-tracking-config"> written by
   snippets/rx-head.liquid ({ launchUrl, environmentVersion, coBrandedVersion,
   template }). This file is only included when settings.rx_tracking_enabled
   is on. It is deferred, so #rx-page-meta (rendered by a section in <body>)
   is already parsed when it runs, and it is read before Launch is injected.
   ========================================================================== */
(function () {
  'use strict';

  var node = document.getElementById('rx-tracking-config');
  if (!node) return;

  var config;
  try {
    config = JSON.parse(node.textContent);
  } catch (e) {
    return;
  }

  // 1. Page name. WP page names, copied exactly from cmpScripts.js / cmpCollections.js.
  // Templates not listed here set their page name with the rx-page-meta section.
  // page.rx-collection (/rolex-collection, Corners) is deliberately absent: WP sent no page type there.
  var TEMPLATE_PAGE_TYPES = {
    'page.rx-landing': 'home page',
    'page.rx-watchmaking': 'watchmaking page',
    'page.rx-new-watches': 'new watches page',
    'page.rx-team': 'team page',
    'page.rx-servicing': 'servicing your rolex page',
    'page.rx-showroom': 'showroom page',
    'page.rx-contact': 'store contact page',
    'page.rx-contact-form': 'contact form page',
    'page.rx-retailer': 'rolex at page',
    'blog.rx-world-of-rolex': 'article hub page',
    'article.rx-world-of-rolex': 'article page'
  };

  var pageType = TEMPLATE_PAGE_TYPES[config.template] || '';
  var familyName = '';
  var product = null;

  // Override from the rx-page-meta section, when the template has one.
  var metaNode = document.getElementById('rx-page-meta');
  if (metaNode) {
    try {
      var meta = JSON.parse(metaNode.textContent);
      if (meta.page_type && meta.page_type !== 'auto') pageType = meta.page_type;
      if (meta.family_name) familyName = String(meta.family_name).trim();
      if (meta.product && typeof meta.product === 'object') product = meta.product;
    } catch (e) {
      // Ignore malformed meta; fall back to the template map.
    }
  }

  // Model pages: family name from the product title, exactly as WP
  // cmpScripts.js loadDataLayerModels(): drop number-only words (except when
  // the title starts with 1908), hyphenate, lowercase, then three renames.
  function modelFamilyFromTitle(title) {
    var words = String(title || '').replace(/\s+$/, '').split(' ');
    if (words[0] !== '1908') {
      words = words.filter(function (word) { return !/^\d+$/.test(word); });
    }
    var name = words.join(' ').split(' ').join('-').toLowerCase();
    if (name === 'deepsea-challenge') name = 'deepsea';
    if (name === 'submariner-date') name = 'submariner';
    if (name === 'explorer-ii') name = 'explorer';
    return name;
  }
  if (pageType === 'model page' && !familyName && product) {
    familyName = modelFamilyFromTitle(product.title);
  }

  // 2. Data layer. It must exist before Launch runs, as in WP.
  if (pageType) {
    var page = { pageType: pageType };
    // WP sends pageFamilyName on family pages, model pages and accessory pages.
    if (familyName && (pageType.indexOf('family page') === 0 || pageType === 'model page' || pageType === 'accessories model page')) {
      page.pageFamilyName = familyName;
    }
    window.digitalDataLayer = {
      environment: {
        environmentVersion: config.environmentVersion,
        coBrandedVersion: config.coBrandedVersion
      },
      page: page
    };
    // WP model pages also send products.productRMC (the reference shown under the title).
    if (pageType === 'model page' && product && product.rmc) {
      window.digitalDataLayer.products = { productRMC: String(product.rmc) };
    }
  }

  // 3. Adobe Launch, always (consent is applied inside Launch via rlx-consent).
  if (!config.launchUrl) return;

  var script = document.createElement('script');
  script.src = config.launchUrl;
  script.async = true;
  document.head.appendChild(script);
})();
